import moment from "moment";
import { GenderOptions } from "../../../../Common/Constant";
import { getNormalizedOptionValue } from "../../../ABLTC/SubComponents/SelectOptions";

const getOwnerDetailsFromId = (value, ownerList) => {
    return ownerList !== undefined && ownerList.length !== 0 && ownerList.find(item => item.covrGeneratedID === value);
}

const handleCheckNull = (value) => {
    return (value === null || value === undefined) ? '' : value;
}

export const PrefillCreateCaseInsuredInfo = (fullForm, setValue, listOfFields, isOther, isSecondaryInsuredOther, isMSEnableRelationshipToOwner) => {
    const retrieveAccount = fullForm && fullForm.pages && fullForm.pages.retrieveAccount;
    const soleProprieter = retrieveAccount && retrieveAccount.clientData && retrieveAccount.clientData.soleProprieter;

    const ownerList = [...retrieveAccount && retrieveAccount.clientData && retrieveAccount.clientData.owners] || [];
    if (soleProprieter && soleProprieter.length > 0) {
        // add sole proprieter data in owner list
        retrieveAccount.clientData.soleProprieter.forEach(item => ownerList.push(item));
    }
    let insuredBasicInfoFields = fullForm.pages.insuredBasicInfo;
    if (retrieveAccount.insured && retrieveAccount.insured !== 'Other') {
        const insuredData = getOwnerDetailsFromId(retrieveAccount.insured, ownerList);
        insuredBasicInfoFields = {
            ...insuredBasicInfoFields,
            proposedInsuredFirstName: handleCheckNull(insuredData.firstName),
            proposedInsuredMiddleInitial: handleCheckNull(insuredData.middleName) ? handleCheckNull(insuredData.middleName) : (insuredBasicInfoFields.proposedInsuredMiddleInitial || ''),
            proposedInsuredMiddleNameDisabled: !!handleCheckNull(insuredData.middleName),
            proposedInsuredLastName: handleCheckNull(insuredData.lastName),
            gender: fullForm.pages.insuredBasicInfo.gender ? fullForm.pages.insuredBasicInfo.gender : handleCheckNull(getNormalizedOptionValue(insuredData.gender && insuredData.gender.trim(), GenderOptions)),
            proposedInsuredGenderDisabled: !!handleCheckNull(getNormalizedOptionValue(insuredData.gender && insuredData.gender.trim(), GenderOptions)),
            birthdate: handleCheckNull(insuredData.dateOfBirth) === '' ? '' : moment(insuredData.dateOfBirth).format('MM/DD/YYYY'),
            state: handleCheckNull(insuredData.state),
            insuredRelationshipWithOwner: isMSEnableRelationshipToOwner ? 'Self' : '',
            isOther: false,
        }
    }
    else if (retrieveAccount.insured === 'Other' && !isOther) {
        insuredBasicInfoFields = {
            ...insuredBasicInfoFields,
            proposedInsuredFirstName: '',
            proposedInsuredMiddleInitial: '',
            proposedInsuredLastName: '',
            proposedInsuredMiddleNameDisabled: false,
            gender: '',
            proposedInsuredGenderDisabled: false,
            birthdate: '',
            state: '',
            maritalStatus: '',
            tobacco: '',
            proposedInsuredEmail: '',
            proposedInsuredPhone: '',
            insuredRelationshipWithOwner: '',
            isOther: true,
        }
    }

    if (retrieveAccount.secondInsured && retrieveAccount.secondInsured !== 'Other') {
        const secondInsuredData = getOwnerDetailsFromId(retrieveAccount.secondInsured, ownerList);
        insuredBasicInfoFields = {
            ...insuredBasicInfoFields,
            secondaryInsuredFirstName: handleCheckNull(secondInsuredData.firstName),
            secondaryInsuredMiddleInitial: handleCheckNull(secondInsuredData.middleName) ? handleCheckNull(secondInsuredData.middleName) : (insuredBasicInfoFields.secondaryInsuredMiddleInitial || ''),
            secondaryInsuredMiddleNameDisabled: !!handleCheckNull(secondInsuredData.middleName),
            secondaryInsuredLastName: handleCheckNull(secondInsuredData.lastName),
            secondaryInsuredGender: fullForm.pages.insuredBasicInfo.secondaryInsuredGender ? fullForm.pages.insuredBasicInfo.secondaryInsuredGender : handleCheckNull(getNormalizedOptionValue(secondInsuredData.gender && secondInsuredData.gender.trim(), GenderOptions)),
            secondaryInsuredGenderDisabled: !!handleCheckNull(getNormalizedOptionValue(secondInsuredData.gender && secondInsuredData.gender.trim(), GenderOptions)),
            secondaryInsuredBirthdate: handleCheckNull(secondInsuredData.dateOfBirth) === '' ? '' : moment(secondInsuredData.dateOfBirth).format('MM/DD/YYYY'),
            secondaryInsuredState: handleCheckNull(secondInsuredData.state),
            secondaryInsuredRelationshipWithOwner: isMSEnableRelationshipToOwner ? 'Self' : '',
            isSecondaryInsuredOther: false,
        }
    }
    else if (retrieveAccount.secondInsured === 'Other' && !isSecondaryInsuredOther) {
        insuredBasicInfoFields = {
            ...insuredBasicInfoFields,
            secondaryInsuredFirstName: '',
            secondaryInsuredMiddleInitial: '',
            secondaryInsuredMiddleNameDisabled: false,
            secondaryInsuredLastName: '',
            secondaryInsuredGender: '',
            secondaryInsuredGenderDisabled: false,
            secondaryInsuredBirthdate: '',
            secondaryInsuredState: '',
            secondaryInsuredMaritalStatus: '',
            secondaryInsuredTobacco: '',
            secondaryInsuredEmail: '',
            secondaryInsuredPhone: '',
            secondaryInsuredRelationshipWithOwner: '',
            isSecondaryInsuredOther: true,
        }
    }
    fullForm.pages.insuredBasicInfo = insuredBasicInfoFields;
    listOfFields.forEach((field) => {
        setValue(field, insuredBasicInfoFields[field]);
    });
}



// WEBPACK FOOTER //
// ./src/components/Product/SharedComponents/BasicInfo/SubComponents/PrefillCreateCaseInsuredInfo.js